import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faTwitter, faTiktok, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../../../Context/LanguageContext";
import "./Footer.css";


export default function Footer ()
{
    const { lang } = useLanguage();
    const isAr = lang === "ar";
    const year = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="footer-container">
                <div className="footer-grid">

                    {/* الشعار + وصف مختصر */ }
                    <div className="footer-col footer-col--brand">
                        <h3 className="footer-logo">{ isAr ? "متجرنا" : "Our Store" }</h3>
                        <p className="footer-desc">
                            { isAr
                                ? "وجهتك المفضلة للتسوق الإلكتروني، منتجات أصلية وتوصيل سريع لكل المناطق."
                                : "Your favorite online shopping destination — authentic products and fast delivery." }
                        </p>
                        <div className="footer-social">
                            <a href="https://www.facebook.com/saleem2020r/" aria-label="Facebook"><FontAwesomeIcon icon={ faFacebookF } /></a>
                            <a href="https://www.instagram.com/saleem2020r/" aria-label="Instagram"><FontAwesomeIcon icon={ faLinkedin } /></a>
                            <a href="https://www.linkedin.com/in/saleem-farhan-6b3b2b282/" aria-label="Twitter"><FontAwesomeIcon icon={ faTwitter } /></a>
                            <a href="https://www.tiktok.com/@saleem2020r" aria-label="TikTok"><FontAwesomeIcon icon={ faTiktok } /></a>
                        </div>
                    </div>

                    {/* روابط سريعة */ }
                    <div className="footer-col">
                        <h4>{ isAr ? "روابط سريعة" : "Quick Links" }</h4>
                        <ul>
                            <li><Link to="/">{ isAr ? "الرئيسية" : "Home" }</Link></li>
                            <li><Link to="/about-us">{ isAr ? "من نحن" : "About Us" }</Link></li>
                            <li><Link to="/websitecategories">{ isAr ? "الفئات" : "Categories" }</Link></li>
                            <li><Link to="/profile">{ isAr ? "حسابي" : "My Account" }</Link></li>
                            <li><Link to="/orders">{ isAr ? "طلباتي" : "My Orders" }</Link></li>
                        </ul>
                    </div>

                    {/* السياسات القانونية */ }
                    <div className="footer-col">
                        <h4>{ isAr ? "معلومات" : "Information" }</h4>
                        <ul>
                            <li><Link to="/privacy-policy">{ isAr ? "سياسة الخصوصية" : "Privacy Policy" }</Link></li>
                            <li><Link to="/terms-conditions">{ isAr ? "الشروط والأحكام" : "Terms & Conditions" }</Link></li>
                            <li><Link to="/refund-policy">{ isAr ? "سياسة الاسترجاع" : "Refund Policy" }</Link></li>
                            <li><Link to="/contact-us">{ isAr ? "تواصل معنا" : "Contact Us" }</Link></li>
                        </ul>
                    </div>

                    {/* التواصل */ }
                    <div className="footer-col">
                        <h4>{ isAr ? "تواصل معنا" : "Get in Touch" }</h4>
                        <ul className="footer-contact-list">
                            <li>
                                <FontAwesomeIcon icon={ faEnvelope } />
                                <a href="mailto:support@yourstore.com">saleemalfarhany@gmail.com</a>
                            </li>
                            <li>
                                <FontAwesomeIcon icon={ faPhone } />
                                <a href="tel:+966500000000" dir="ltr">+967771949015</a>
                            </li>
                        </ul>
                    </div>

                </div>

                <div className="footer-bottom">
                    <p>
                        © { year } { isAr ? "متجرنا" : "Our Store" }. { isAr ? "جميع الحقوق محفوظة." : "All rights reserved." }
                    </p>
                </div>
            </div>
        </footer>
    );
}
